// src/main.ts

// Import the explicit router initializer instead of relying on side-effects
import { initRouter } from "./router";

import "./index.css";
import "./pages/Home.css";

import { useAuth } from "./context/useAuth";
import { useTheme } from "./context/useTheme";

/**
 * Orchestrates the application bootstrap process in the correct sequence.
 */
async function bootstrap() {
  try {
    // Apply the user's existing theme before waiting on authentication so
    // the first painted frame already matches the configured theme.
    const { theme, applyTheme } = useTheme();
    applyTheme(theme);

    // Initialize Authentication state before rendering routed content.
    const { init } = useAuth();
    await init();

    // Start the single-page router now that app state is ready.
    initRouter();
  } catch (error) {
    console.error("Application bootstrap failed:", error);
  }
}

// Execute immediately if the DOM is already interactive/complete,
// otherwise attach to the DOMContentLoaded event listener.
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootstrap, { once: true });
} else {
  void bootstrap();
}
